import { graphql } from "gatsby";
import {
  KlarnaOrderConfirmation,
  KlarnaPaymentCartWrapper,
  LocationHelper,
  SimplifyGatsbyQuery,
  multipleClassNames,
} from "@parksandresorts/core";
import styles from "./general-content-block.module.less";

export default function GeneralContentBlock(props: SimplifyGatsbyQuery<Queries.GeneralContentBlockFragment>) {
  const title = props.title;
  const preamble = props.preamble?.preamble;
  const description = props.description?.childMarkdownRemark?.html;

  const queryParams = LocationHelper.getQueryParams();
  const cartId = queryParams["cartId"]?.[0] ?? "";
  const orderId = queryParams["orderId"]?.[0] ?? "";

  const renderContent = () => {
    switch (props.useShopServiceComponent) {
      case "SHOP_SERVICE_PAYMENT":
        return <KlarnaPaymentCartWrapper enabled />;
      case "SHOP_SERVICE_CONFIRMATION":
        return <KlarnaOrderConfirmation cartId={cartId} klarnaOrderId={orderId} />;
      default:
        return (
          <div className={styles.contentWrapper}>
            {title && <h1 className={styles.title}>{title}</h1>}
            {preamble && <div className={multipleClassNames("preamble", styles.preamble)}>{preamble}</div>}
            {description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />}
          </div>
        );
    }
  };

  return (
    <section
      className={`block block--with-utility general-content-block ${styles.section}`}
      data-contentful-id={props.contentful_id}
    >
      <div className={["block--max-width-narrow block--padded block--floating", styles.outerWrapper].join(" ")}>
        {renderContent()}
      </div>
    </section>
  );
}

export const fragmentGeneralContentBlock = graphql`
  fragment GeneralContentBlock on ContentfulGeneralContentBlock {
    contentful_id
    id
    title
    componentTheme
    preamble {
      preamble
    }
    description {
      childMarkdownRemark {
        html
      }
    }
    shortDescriptionInList
    category
    link {
      ...Link
    }
    pageLink {
      slug
    }
    imageInList {
      description
      file {
        url
      }
      gatsbyImageData(width: 480)
    }
    speechBubbleInverseColors
    imageInBubble {
      file {
        url
      }
    }
    label
    isAdInList
    adLink {
      title
      internalLink {
        slug
      }
      externalUrl
    }
    tags {
      id
      title
    }
    useShopServiceComponent
  }
`;
